import React from 'react';
import '../../App.css'
import ComingSoonHero from '../ComingSoonHero';
import Footer from '../Footer';

export default function Stats() {
    return (
        <>
            <ComingSoonHero />
            <Footer />
        </>
    );
}